export default __webpack_public_path__ + "static/media/mobile14.91ecf69e.jfif";